import React, { useState, useEffect } from "react";
import "../../styles/Modal.scss"; // Import the CSS file
import search from "../Images/Search.png";
import tick from "../Icons/tick.png";
import name from "../Icons/name.png";
import bkash from "../Icons/bkash.png";
import address from "../Icons/Location.png";
import thana from "../Icons/Admin.png";
import district from "../Icons/district.png";
import lead from "../Icons/lead.png";
import assigned from "../Icons/home_work.png";
import add from "../Icons/add_circle.png";
import spot from "../Icons/spot.png";
import avatar from "../Icons/Avatar.png";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import DoneIcon from "@material-ui/icons/Done";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { CircularProgress, Collapse } from "@material-ui/core";
import axios from "axios";
import SpotCodeSearchInput from "../SpotCodeSearchInput";
import AxiosClient from "../../../../Network/AxiosClient";

const AssignModal = ({
  isOpen,
  onClose,
  selectedAssignItem,
  rowDetails,
  fetchTableData,
}) => {
  const [selectedSpotCode, setSelectedSpotCode] = useState("");
  const [selectedPeople, setSelectedPeople] = useState(null);
  const [isSaveButtonActive, setIsSaveButtonActive] = useState(false);
  const [isSaveButtonClicked, setIsSaveButtonClicked] = useState(false); // New state variable
  const [availableMAOs, setAvailableMAOs] = useState([]);
  const [personImages, setPersonImages] = useState({});
  const [showNotification, setShowNotification] = useState(false);
  const [response, setResponse] = useState(null);
  const [Message, setMessage] = useState(null);
  const [fieldForceList, setFieldForceList] = useState([]);
  const [fetching, setFetching] = useState(true);
  const [param, setParam] = useState(null);

  const handleAddPerson = (person) => {
    setSelectedPeople(person);
  };

  const handleSaveChanges = async () => {
    try {
      var leadsArray = [];
      rowDetails.map((i) => leadsArray.push({ id: i.id }));
      const postBody = {
        leads: [...leadsArray],
        [param]: selectedSpotCode,
        field_force_id: selectedPeople.id,
      };

      console.log(postBody);

      fetchTableData("unassigned", 0);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/ekyc/v1/assign-lead`,
        postBody,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      );
      setResponse(response);

      if (response.status === 200) {
        setShowNotification(true);
        setMessage(response.data.message); // Set the message from the API response
        setIsSaveButtonActive(false);
        onClose();
        fetchTableData("unassigned", 0);
        fetchTableData("assigned", 0);
        fetchTableData("validated", 0);
      } else {
        fetchTableData("unassigned", 0);
        setMessage(response.data.message);
        console.error("Error assigning person to the row:", response.data);
      }
    } catch (error) {
      fetchTableData("unassigned", 0);
      console.log(error);
      setMessage("Error assigning person to the row"); // Set the error message from the API response
      console.error("Error assigning person to the row:", error);
    }
  };

  const handleSpotCodeChange = async (spotCode, param) => {
    setFetching(true);
    setParam(param);
    setSelectedSpotCode(spotCode);
    // Clear the previous people list
    setIsSaveButtonActive(false);
    setPersonImages({}); // Clear the previous person images

    if (spotCode) {
      try {
        const response = await AxiosClient.get(
          `${process.env.REACT_APP_API_URL}/api/admin_panel/v1/mdo-list?${param}=${spotCode}`,
          {
            headers: {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
            },
          }
        );
        //console.log("Selected people response:", response.data.data);
        const peopleData = response.data.data;

        // Extract image URLs and store them in personImages
        const images = {};
        for (const person of peopleData) {
          images[person.id] = person.image;
        }

        //setSelectedPeople(peopleData);
        setFieldForceList(peopleData);
        setPersonImages(images);
        setFetching(false);
      } catch (error) {
        setFetching(false);
        console.error("Error fetching selected people:", error);
      }
    }
  };

  const config = [
    { title: "Name", key: "lead_name" },
    { title: "Owner", key: "owner_name" },
    { title: "Wallet Number", key: "lead_number" },
    { title: "Address", key: "address" },
    { title: "Thana/Upazilla", key: "thana" },
    { title: "District", key: "district" },
    {
      title: "Lead generated",
      key: "submission_date",
      alt: "Sample Lead generated",
    },
    { title: "Product type", key: "product_type" },
    { title: "Emergency contact", key: "emergency_contact" },
    { title: "Expiration date", key: "expiration_date" },
  ];

  // console.log(rowDetails);

  return (
    isOpen &&
    selectedAssignItem && (
      <div className="modal">
        <div className="modal-content">
          <div className="close-button" onClick={onClose}>
            <span>&times;</span>
          </div>
          <p>Assign field force</p>
          {rowDetails.length > 1 && (
            <p className="leads-number"> {rowDetails.length} leads selected</p>
          )}
          <Collapse in={Message !== null}>
            <div
              className={`assign-msg ${
                response?.status === 200 ? "green-bg" : "red-bg"
              }`}
            >
              {Message}
            </div>
          </Collapse>
          <div className="section">
            {rowDetails.length === 1 ? (
              <div className="left-section">
                {config.map((item) => (
                  <div className="detail" key={item.key}>
                    <strong className="field-heading">
                      <img src={name} alt="Field Icon" className="field-icon" />
                      {item.title}
                    </strong>
                    <div>
                      {rowDetails[0][item.key] ?? (
                        <p className="not-available">Not available</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="left-section accordion-assign">
                {rowDetails.map((row) => (
                  <Accordion key={row.id}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <div className="details">
                        <strong>{row.lead_name}</strong>
                        <div>{row.lead_number}</div>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      {" "}
                      {config.map((item) => (
                        <div className="detail" key={item.key}>
                          <strong className="field-heading">
                            <img
                              src={name}
                              alt="Field Icon"
                              className="field-icon"
                            />
                            {item.title}
                          </strong>
                          <div>{row[item.key]}</div>
                        </div>
                      ))}
                    </AccordionDetails>
                  </Accordion>
                ))}
              </div>
            )}

            <div className="right-section">
              <SpotCodeSearchInput
                onSpotCodeSelect={handleSpotCodeChange}
                onChangeFieldForceType={() => {
                  setFieldForceList([]);
                  setSelectedPeople(null);
                }}
              />

              <div className="people-list">
                {!fetching && fieldForceList.length === 0 && (
                  <div className="empty-field-force">No field force found</div>
                )}
                {fieldForceList.map((person, index) => (
                  <div
                    key={index}
                    className="person"
                    onClick={() => handleAddPerson(person)}
                    style={{
                      background:
                        selectedPeople && person.id === selectedPeople.id
                          ? "#e2136e2e"
                          : "transparent",
                    }}
                  >
                    <img
                      src={personImages[person.id]}
                      alt={`${person.name}'s Image`}
                      className="person-image"
                    />
                    <div className="person-details">
                      <div className="person-name">{person.name}</div>
                      <div className="person-phone">
                        {person.contact_number}
                      </div>
                    </div>
                    <button
                      className="add-button"
                      onClick={() => handleAddPerson(person)}
                      style={{ background: "transparent" }}
                    >
                      {selectedPeople && person.id === selectedPeople.id ? (
                        <DoneIcon
                          style={{ color: "#e2136e", transform: "scale(1.1)" }}
                        />
                      ) : (
                        <AddCircleOutlineIcon style={{ color: "#362b73" }} />
                      )}
                    </button>
                  </div>
                ))}
              </div>

              <div className="button-section">
                <button className="cancel-button" onClick={onClose}>
                  Cancel
                </button>
                <button
                  className={`save-button ${
                    selectedPeople ? "active" : "inactive"
                  }`}
                  onClick={() => {
                    handleSaveChanges();
                  }}
                  disabled={selectedPeople ? false : true}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default AssignModal;
